import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class UploadImage extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Uploader/Upload");
  }
  setFormData(data) {

    super.setFormData(data);
  }
}

export { UploadImage };
